import React, { useEffect, useState } from 'react';
import './LeftContent.scss';
import ProductCarousel from './ProductCarousel/ProductCarousel';
import LKModal from '../Modal/Modal';

const LeftContentNew = props => {
  const {
    productData,
    // dataLocale: { RECENTLY_VIEWED_PRODUCTS },
  } = props;

  const [showTryOnPopUp, setShowTryOnPopUp] = useState(false);
  const [show360View, setShow360View] = useState(false);
  const [tryOn, setTryOn] = useState(false);

  useEffect(() => {
    console.log('PDP productData', JSON.parse(JSON.stringify(productData || {})));
  });

  const closeTryOn = () => {
    setShowTryOnPopUp(false);
  };

  const close360 = () => {
    setShow360View(false);
  };

  return (
    <div className="od-product-left-container">
      {showTryOnPopUp && productData?.result?.glassOnUrl && (
        <LKModal
          backdrop
          keyboard
          dialogClassName="od-container-modals"
          hideHandler={() => setShowTryOnPopUp(false)}
          showModal={showTryOnPopUp}
          size="large"
        >
          <span className="od-modal-close" onClick={closeTryOn}>
            ×
          </span>
          <iframe
            allowfullscreen
            allow="camera"
            src={productData?.result?.glassOnUrl}
            title="owndays try on"
          ></iframe>
        </LKModal>
      )}

      {show360View && productData?.result?.glassOnUrl && (
        <LKModal
          backdrop
          keyboard
          dialogClassName="od-container-modals"
          hideHandler={() => setShow360View(false)}
          showModal={show360View}
          size="large"
        >
          <span className="od-modal-close" onClick={close360}>
            ×
          </span>
          <iframe
            allowfullscreen
            allow="camera"
            src={`${productData?.result?.glassOnUrl}&mode=viewer`}
            title="owndays try on"
          ></iframe>
        </LKModal>
      )}

      {productData?.result?.imageUrlsDetail?.length && (
        <ProductCarousel
          dataLocale={props.dataLocale}
          productData={productData}
          {...props}
          setShow360View={setShow360View}
          setShowTryOnPopUp={setShowTryOnPopUp}
          setTryOn={setTryOn}
          show360View={show360View}
          showTryOnPopUp={showTryOnPopUp}
          tryOn={tryOn}
        />
      )}
    </div>
  );
};

export default LeftContentNew;
